/**
 * Namespaced form id for the MSR3 profile page. The legacy
 * `AccountSettings/ProfileSettingsForm` still uses `myprofile-form`, so a
 * distinct id here prevents the lifted submit/reset buttons targeting the
 * wrong form if both ever render in the same DOM (Storybook, migration
 * transition, etc.).
 */
export const MSR3_PROFILE_FORM_ID = 'msr3-myprofile-form';
